var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-line"},[_vm._l((_vm.rows),function(e,i){return [_c('span',{key:("text_" + i),class:{ 'share-out': _vm.shareOut }},[_vm._v(" "+_vm._s(e)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }